import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShowProgressComponent } from './show-progress.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ShowProgressComponent],
  exports: [ShowProgressComponent]
})
export class ShowProgressModule {}
